import Icon, { PlusOutlined, SearchOutlined, LoadingOutlined, CloseCircleFilled, CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, DatePicker, Input, message, Modal, Radio, Select, Table } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormTimeline } from "../../../components/FormTimeline/FormTimeline";
import { ModalSearchEquipment } from "../../../components/ModalSearchEquipment/ModalSearchEquipment";
import { CaseReportActions } from "../../../services/caseReport/CaseReportSlice";
import { TimelineActions } from "../../../services/Timeline/TimelineSlice";
import { Tree, TreeNode } from "react-organizational-chart"
import { FormTraining } from "../../../components/FormTraining/FormTraining";
import { ModalBitacoraNotFirmed } from "../../../components/ModalBitacoraNotFirmed/ModalBitacoraNotFirmed";
import { AreaActions } from "../../../services/Area/AreaSlice";
import { TimelineTrainingActions } from "../../../services/TimelineTraining/TimelineTrainingSlice";


export const Training = () => {
    const [option, setOption] = useState('Search')
    const { loadingTraining, trainings } = useSelector(state => state.Timeline)
    const [currentPage, setCurrentPage] = useState(0);
    const { idUser } = useSelector(state => state.Login)
    const [pdfSelected, setPdfSelected] = useState(false)
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState(null);
    const [isEditing1, setIsEditing1] = useState(false);
    const { TimelineTrainings, createTimelineTrainingLoading } = useSelector(state => state.TimelineTraining)

    const dispatch = useDispatch()

    useEffect(() => {
        option === "Search" && dispatch(TimelineActions.getAllTrainings(currentPage))
        option === "Schedule" && dispatch(TimelineTrainingActions.getTimelineTrainings({ userId: idUser }))
    }, [dispatch, currentPage, option])

    const IconAddCronoSvg = () => (
        <svg viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V13H5.022C5.05265 13.3383 5.11458 13.6731 5.207 14H1C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H5.6C5.783 15.358 6.004 15.693 6.257 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H10C10.5304 0 11.0391 0.210714 11.4142 0.585786C11.7893 0.960859 12 1.46957 12 2V7.207C11.6731 7.11447 11.3383 7.05254 11 7.022V2C11 1.73478 10.8946 1.48043 10.7071 1.29289C10.5196 1.10536 10.2652 1 10 1ZM2 3V4C2 4.26522 2.10536 4.51957 2.29289 4.70711C2.48043 4.89464 2.73478 5 3 5H9C9.26522 5 9.51957 4.89464 9.70711 4.70711C9.89464 4.51957 10 4.26522 10 4V3C10 2.73478 9.89464 2.48043 9.70711 2.29289C9.51957 2.10536 9.26522 2 9 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3ZM3 3H9V4H3V3ZM15 12.5C15 13.6935 14.5259 14.8381 13.682 15.682C12.8381 16.5259 11.6935 17 10.5 17C9.30653 17 8.16193 16.5259 7.31802 15.682C6.47411 14.8381 6 13.6935 6 12.5C6 11.3065 6.47411 10.1619 7.31802 9.31802C8.16193 8.47411 9.30653 8 10.5 8C11.6935 8 12.8381 8.47411 13.682 9.31802C14.5259 10.1619 15 11.3065 15 12.5ZM11 10.5C11 10.3674 10.9473 10.2402 10.8536 10.1464C10.7598 10.0527 10.6326 10 10.5 10C10.3674 10 10.2402 10.0527 10.1464 10.1464C10.0527 10.2402 10 10.3674 10 10.5V12H8.5C8.36739 12 8.24021 12.0527 8.14645 12.1464C8.05268 12.2402 8 12.3674 8 12.5C8 12.6326 8.05268 12.7598 8.14645 12.8536C8.24021 12.9473 8.36739 13 8.5 13H10V14.5C10 14.6326 10.0527 14.7598 10.1464 14.8536C10.2402 14.9473 10.3674 15 10.5 15C10.6326 15 10.7598 14.9473 10.8536 14.8536C10.9473 14.7598 11 14.6326 11 14.5V13H12.5C12.6326 13 12.7598 12.9473 12.8536 12.8536C12.9473 12.7598 13 12.6326 13 12.5C13 12.3674 12.9473 12.2402 12.8536 12.1464C12.7598 12.0527 12.6326 12 12.5 12H11V10.5Z" fill="white" />
        </svg>
    );
    const IconCalendarSvg = () => (
        <svg viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.71289 5.84131H5.30973V7.13942H3.71289V5.84131ZM3.71289 8.43753H5.30973V9.73564H3.71289V8.43753ZM6.90657 5.84131H8.50342V7.13942H6.90657V5.84131ZM6.90657 8.43753H8.50342V9.73564H6.90657V8.43753ZM10.1003 5.84131H11.6971V7.13942H10.1003V5.84131ZM10.1003 8.43753H11.6971V9.73564H10.1003V8.43753Z" fill="white" />
            <path d="M2.11637 12.9811H13.2942C14.1749 12.9811 14.8911 12.3989 14.8911 11.683V3.89434V2.59623C14.8911 1.88032 14.1749 1.29811 13.2942 1.29811H11.6974V0H10.1006V1.29811H5.31005V0H3.71321V1.29811H2.11637C1.23571 1.29811 0.519531 1.88032 0.519531 2.59623V3.89434V11.683C0.519531 12.3989 1.23571 12.9811 2.11637 12.9811ZM13.2942 3.89434L13.295 11.683H2.11637V3.89434H13.2942Z" fill="white" />
        </svg>
    );

    const IconAddCrono = (props) => <Icon component={IconAddCronoSvg} {...props} />;
    const IconCalendar = (props) => <Icon component={IconCalendarSvg} {...props} />;

    const buttons = (t) => {
        t !== "SearchModal" && setOption(t)
    }

    const pageSize = 10
    const totalPages = Math.ceil(trainings[1] / pageSize);

    const onSides = (n) => {
        if (currentPage < totalPages - 1 & n === 1) {
            setCurrentPage(prev => prev + n)
        }
        if (currentPage > 0 & n === -1) {
            setCurrentPage(prev => prev + n)
        }
    }

    const generateNButtons = (N, onClick, currentPage, totalPages) =>
        [...Array(N).keys()].map(i => (
            currentPage === i ? <div className='radiobuttonSelected'
                key={`Button_${i}`}
                onClick={() => onClick(i)}
            >
                {i + 1}
            </div>
                :
                Math.abs(i - currentPage) <= 2 ?
                    <div className='radiobutton'
                        key={`Button_${i}`}
                        onClick={() => onClick(i)}
                    >
                        {i + 1}
                    </div>
                    :
                    i === totalPages - 1 ?
                        <div className='radiobutton'
                            key={`Button_${i}`}
                            onClick={() => onClick(i)}
                        >
                            {i + 1}
                        </div>
                        :
                        Math.abs(i - currentPage) === 3 &&
                        <div className='radiobutton'
                            key={`Button_${i}`}
                            onClick={() => onClick(i)}
                        >
                            ...
                        </div>
        ))

    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    const statusCycle = ["", "P", "RP", "E"];

    const rotateStatus = (current) => {
        const index = statusCycle.indexOf(current);
        return statusCycle[(index + 1) % statusCycle.length];
    };

    const isEditing = (record) => record.key === editingKey;

    const handleAdd = () => {
        setIsEditing1(false);
        const newKey = Date.now().toString();
        setData([
            ...data,
            {
                key: newKey,
                tema: "",
                editable: true,
                ...Object.fromEntries(months.map((m) => [m, ""])),
            },
        ]);
        setEditingKey(newKey);
    };

    useEffect(() => {
        if (TimelineTrainings) {
            const monthMapping = {
                Ene: "january",
                Feb: "february",
                Mar: "march",
                Abr: "april",
                May: "may",
                Jun: "june",
                Jul: "july",
                Ago: "august",
                Sep: "september",
                Oct: "october",
                Nov: "november",
                Dic: "december",
            };

            const newData = TimelineTrainings.map((item, index) => ({
                key: index,
                id: item.id,
                tema: item.tema,
                editable: false,
                ...Object.fromEntries(
                    months.map((m) => [m, item[monthMapping[m]]])
                ),
            }));
            setData(newData);
        }
    }, [TimelineTrainings]);

    const save = (key) => {
        setEditingKey(null);
        const newData = [...data];
        const index = newData.findIndex((item) => key === item.key);
        newData[index].user = idUser;
        if (isEditing1) {
            dispatch(TimelineTrainingActions.editTimelineTraining(newData[index]))
            setIsEditing1(false);
        } else {
            dispatch(TimelineTrainingActions.createTimelineTraining(newData[index]))
        }
        if (index > -1) {
            newData[index].editable = false;
            setData(newData);
        }
    };

    const edit = (key) => {
        setIsEditing1(true);
        setEditingKey(key);
        const newData = [...data];
        const index = newData.findIndex((item) => item.key === key);
        if (index > -1) {
            newData[index].editable = true;
            setData(newData);
        }
    };

    const handleChange = (key, month) => {
        const newData = [...data];
        const record = newData.find((item) => item.key === key);
        if (record && record.editable) {
            record[month] = rotateStatus(record[month]);
            setData(newData);
        }
    };

    const handleTemaChange = (key, value) => {
        const newData = [...data];
        const record = newData.find((item) => item.key === key);
        if (record && record.editable) {
            record.tema = value;
            setData(newData);
        }
    };

    const columns = [
        {
            title: "Tema",
            dataIndex: "tema",
            key: "tema",
            render: (_, record) =>
                record.editable ? (
                    <Input.TextArea
                        value={record.tema}
                        autoSize
                        width="10vw"
                        onChange={(e) => handleTemaChange(record.key, e.target.value)}
                    />
                ) : (
                    <div style={{ width: '10vw' }}>{record.tema}</div>
                ),
        },
        ...months.map((month) => ({
            title: month,
            dataIndex: month,
            key: month,
            align: "center",
            render: (_, record) => (
                <div
                    onClick={() => handleChange(record.key, month)}
                    style={{
                        cursor: record.editable ? "pointer" : "default",
                        padding: "4px 8px",
                        border: "1px solid #d9d9d9",
                        borderRadius: 4,
                        userSelect: "none",
                    }}
                >
                    {record[month]}
                </div>
            ),
        })),
        {
            title: "Acciones",
            key: "actions",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <Button type="link" onClick={() => save(record.key)}>
                        {createTimelineTrainingLoading ? <LoadingOutlined /> : "Guardar"}
                    </Button>
                ) : (
                    <Button type="link" onClick={() => edit(record.key)}>
                        {createTimelineTrainingLoading ? <LoadingOutlined /> : "Editar"}
                    </Button>
                );
            },
        },
    ];


    return (
        <div className="Training">
            <div className='titleDiv'><p className='inventoryText'>Capacitaciones</p></div>
            <div className='buttonsSection' >
                <div className="buttons">
                    <Button
                        className={option === 'Add' ? "Selected add" : "Unselected add"}
                        onClick={() => buttons('Add')}
                    >
                        <IconAddCrono className="plus" /> Nuevo
                    </Button>
                    <Button
                        className={option === 'Search' ? "Selected" : "Unselected"}
                        onClick={() => buttons('Search')}
                    >
                        {!loadingTraining ? <SearchOutlined className="plus" /> : <LoadingOutlined className='plus' />} Buscar
                    </Button>
                    <Button
                        className={option === 'Schedule' ? "Selected" : "Unselected"}
                        onClick={() => buttons('Schedule')}
                        style={{ marginLeft: '1vw' }}
                    >
                        <IconCalendar className="plus" /> Programar
                    </Button>
                </div>
            </div>
            {option == "Add" && <FormTraining />}
            {option === "Search" && trainings &&
                <div className="columnsNameTimeline">
                    <p>Sede</p>
                    <p >Area</p>
                    <p >Dependencia</p>
                    <p >Actividades</p>
                    <p>Agente</p>
                    <p >Horas</p>
                    <p>Fecha</p>
                </div>}
            {option == "Search" &&
                <div className="div">
                    {trainings && trainings[0].map(d => (
                        <div className="TimelineCard" key={d.id} onClick={() => setPdfSelected(d.pdf)}>
                            <p style={{ fontSize: '0.8vw' }}>{d.headquarter === null ? 'Sede principal' : d.headquarter.name}</p>
                            <p style={{ fontSize: '0.8vw' }}>{d.dependency.area.name}</p>
                            <p style={{ fontSize: '0.8vw' }}>{d.dependency.name}</p>
                            <p style={{ fontSize: '0.8vw' }}>{d.activities}</p>
                            <p style={{ fontSize: '0.8vw' }}>{d.userCreator.person.name + " " + d.userCreator.person.secondName + " " + d.userCreator.person.lastName + " " + d.userCreator.person.secondLastName}</p>
                            <p style={{ fontSize: '0.8vw' }}>{d.hours}</p>
                            <p style={{ fontSize: '0.8vw' }}>{new Date(d.date).getDate() + "/" + (new Date(d.date).getMonth() + 1) + "/" + new Date(d.date).getFullYear()}</p>
                            {idUser === d.userCreator.id ?
                                <div className='deleteDiv'><CloseOutlined className='deleteIcon'
                                    onClick={() => {
                                        if (window.confirm('¿Seguro deseas eliminar esta capacitacion?')) {
                                            dispatch(TimelineActions.deleteTraining({ "id": d.id }))
                                        }
                                    }}
                                /></div>
                                :
                                <div className='deleteDiv'><CloseOutlined className='deleteIcon' style={{ visibility: 'hidden' }} /></div>}
                        </div>
                    ))}
                </div>
            }
            {option == "Search" && trainings &&
                <div className="divPages">
                    <div className='showingText'>
                        Mostrando {((currentPage) * pageSize) + 1} - {Math.min((currentPage + 1) * pageSize, trainings[1])} de {trainings[1]} elementos
                    </div>
                    <div className='divButtonsPages'>
                        <div className='sidesButtons' onClick={() => onSides(-1)}>Anterior</div>
                        <Radio.Group className='RadioButtonGroup' buttonStyle={'solid'} defaultValue={0} size={totalPages}>
                            {generateNButtons(totalPages, setCurrentPage, currentPage, totalPages)}
                        </Radio.Group>
                        <div className='sidesButtons' onClick={() => onSides(1)}>Siguiente</div>
                    </div>
                </div>
            }
            {pdfSelected &&
                <Modal
                    visible={true}
                    onCancel={() => setPdfSelected(false)}
                    onOk={() => setPdfSelected(false)}
                    width={'90vw'}
                >
                    <div style={{ width: '85vw', height: '65vh' }}>
                        <embed
                            src={pdfSelected.startsWith("data:application/pdf;base64,") ? pdfSelected : "data:application/pdf;base64," + pdfSelected} type="application/pdf" width="100%" height="100%"
                        />
                    </div>
                </Modal>}

            {option === "Schedule" &&
                <div>
                    <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
                        Añadir nuevo
                    </Button>
                    <Table columns={columns} dataSource={data} pagination={false} />
                </div>
            }
        </div>
    )
}
